import {runSlot} from '@gongxigames/framework/slot';
import {gameConfig} from 'src/configs/GameConfig';
import {componentsConfig} from 'src/configs/componentsConfig';

runSlot({gameConfig, componentsConfig});
